import * as Sentry from '@sentry/vue'
import {
  breadcrumbsIntegration,
  browserTracingIntegration,
  captureConsoleIntegration,
  dedupeIntegration,
  httpClientIntegration,
  httpContextIntegration,
} from '@sentry/vue'
import type { UserModule } from '@/types'

export const reloadErrors = [
  'Failed to fetch dynamically imported module', // // vite issue with new releases and old chunks: https://stackoverflow.com/questions/69300341/typeerror-failed-to-fetch-dynamically-imported-module-on-vue-vite-vanilla-set
  'Unable to preload CSS',
  'Importing a module script failed',
  'error loading dynamically imported module',
  'Connection to Indexed Database server lost. Refresh the page to try again',
  'Non-Error promise rejection captured', // https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-954602174
]

export const install: UserModule = (app, router) => {
  if (import.meta.env.VITE_APP_SENTRY_ENVIRONMENT) {
    Sentry.init({
      app,
      debug: false,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN_URL,
      tunnel: import.meta.env.VITE_APP_SENTRY_TUNNEL,
      integrations: [
        browserTracingIntegration({ router }),
        captureConsoleIntegration({
          levels: [ 'error' ], 
        }),
        httpContextIntegration(),
        httpClientIntegration(),
        breadcrumbsIntegration({
          console: true,
          dom: true,
          fetch: true,
          history: true,
          sentry: true,
          xhr: true,
        }),
        dedupeIntegration(),

      ],
      ignoreErrors: [ ...reloadErrors ],
      tracePropagationTargets: [
        'localhost',
        'portal.swipe4work.com',
        'portal.test.swipe4work.com',
        'api.swipe4work.com',
        'api.test.swipe4work.com',
        /^\//,
      ],
      
      release: `${import.meta.env.VITE_GIT_SHA}`,
      /*
       * Set tracesSampleRate to 1.0 to capture 100%
       * of transactions for performance monitoring.
       * We recommend adjusting this value in production
       */
      tracesSampleRate: import.meta.env.VITE_APP_SENTRY_SAMPLE_RATE,
      environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT,
      sendDefaultPii: true,
    })
  }
}
